export const clientEmailConfig = {
  emailHandler: 'SENDGRID',
  clientId: '080c99df-22c4-4744-86e4-bfdfde2a5794',
  activeDomainId: '20902638',
  activeDomainName: 'incentivio.com',
  fromEmail: null,
  fromEmailedName: 'SquareRestaurants',
  replyTo: 'palmlanedev@incentivio.com',
  replyToName: null,
  clientSendgridApiKey: 'AQICA....',
  subUserId: '45321540',
  subUserName: 'SquareRestaurants_080c99df-22c4-4744-86e4-bfdfde2a5794',
  domains: [
    {
      id: '080c99df-22c4-4744-86e4-bfdfaaaaa',
      externalId: '20902638',
      subdomain: 'em6935',
      domain: 'incentivio.com',
      username: 'unified_acct_USd50724f96033e9a4cdbe23203969dd71',
      valid: true,
      active: true,
      clientSpecific: false,
      dns: {
        mail_cname: {
          valid: 'true',
          type: 'cname',
          host: 'em6935.incentivio.com',
          data: 'u42748229.wl230.sendgrid.net',
        },
        dkim1: {
          valid: 'true',
          type: 'cname',
          host: 's1._domainkey.incentivio.com',
          data: 's1.domainkey.u42748229.wl230.sendgrid.net',
        },
        dkim2: {
          valid: 'true',
          type: 'cname',
          host: 's2._domainkey.incentivio.com',
          data: 's2.domainkey.u42748229.wl230.sendgrid.net',
        },
      },
    },
    {
      id: null,
      externalId: '20923863',
      subdomain: 'em924',
      domain: 'aeturnum.com',
      username: 'unified_acct_USd50724f96033e9a4cdbe23203969dd71',
      valid: true,
      active: false,
      clientSpecific: false,
      dns: {
        mail_cname: {
          valid: 'true',
          type: 'cname',
          host: 'em924.aeturnum.com',
          data: 'u42748229.wl230.sendgrid.net',
        },
        dkim1: {
          valid: 'true',
          type: 'cname',
          host: 's1._domainkey.aeturnum.com',
          data: 's1.domainkey.u42748229.wl230.sendgrid.net',
        },
        dkim2: {
          valid: 'true',
          type: 'cname',
          host: 's2._domainkey.aeturnum.com',
          data: 's2.domainkey.u42748229.wl230.sendgrid.net',
        },
      },
    },
    {
      id: '000000-22c4-4744-86e4-bfdfaaaaa',
      externalId: '22017468',
      subdomain: 'em3606',
      domain: 'incentiviotest.com',
      username: 'SquareRestaurants_080c99df-22c4-4744-86e4-bfdfde2a5794',
      valid: false,
      active: false,
      clientSpecific: true,
      dns: {
        mail_cname: {
          valid: 'false',
          type: 'cname',
          host: 'em3606.incentiviotest.com',
          data: 'u45321540.wl041.sendgrid.net',
        },
        dkim1: {
          valid: 'false',
          type: 'cname',
          host: 's1._domainkey.incentiviotest.com',
          data: 's1.domainkey.u45321540.wl041.sendgrid.net',
        },
        dkim2: {
          valid: 'false',
          type: 'cname',
          host: 's2._domainkey.incentiviotest.com',
          data: 's2.domainkey.u45321540.wl041.sendgrid.net',
        },
      },
    },
  ],
};

export const validEmailSuccessResponse = {
  id: '22458658',
  valid: true,
  validation_results: {
    mail_cname: {
      valid: 'true',
      reason:
        'Expected CNAME for "em1481.aeturnum.net" to match "u46089425.wl176.sendgrid.net".',
    },
    dkim1: {
      valid: 'true',
      reason:
        'Expected CNAME for "s1._domainkey.aeturnum.net" to match "s1.domainkey.u46089425.wl176.sendgrid.net".',
    },
    dkim2: {
      valid: 'true',
      reason:
        'Expected CNAME for "s2._domainkey.aeturnum.net" to match "s2.domainkey.u46089425.wl176.sendgrid.net".',
    },
  },
};

export const addNewClientDomainSuccessResponse = {
  ...clientEmailConfig,
  domains: [
    ...clientEmailConfig.domains,
    {
      id: '3432000-22c4-4744-86e4-bfdfaaa92',
      externalId: '12511992',
      subdomain: 'em3606',
      domain: 'newdomain.com',
      username: 'SquareRestaurants_080c99df-22c4-4744-86e4-bfdfde2a5794',
      valid: false,
      active: false,
      clientSpecific: true,
      dns: {
        mail_cname: {
          valid: 'true',
          type: 'cname',
          host: 'em924.newdomain.com',
          data: 'u42748229.wl230.sendgrid.net',
        },
        dkim1: {
          valid: 'true',
          type: 'cname',
          host: 's1._domainkey.newdomain.com',
          data: 's1.domainkey.u42748229.wl230.sendgrid.net',
        },
        dkim2: {
          valid: 'true',
          type: 'cname',
          host: 's2._domainkey.newdomain.com',
          data: 's2.domainkey.u42748229.wl230.sendgrid.net',
        },
      },
      applied: false,
    },
  ],
};
